import {CURRENCIES_RATE_API_URL, EXCHANGE_RATE_API_URL} from './constants';
import {loadCachedData, saveCachedData} from '../../storage';

// Fetch exchange rates from API
export const fetchExchangeRates = async (baseCurrency: string): Promise<ExchangeRates> => {
  // Check cache first
  const cached = loadCachedData<ExchangeRates>(baseCurrency);
  if (cached) {
    return cached;
  }

  // Fetch from API
  const response = await fetch(`${EXCHANGE_RATE_API_URL}/${baseCurrency}`);
  
  if (!response.ok) {
    throw new Error(`Failed to fetch exchange rates: ${response.statusText}`);
  }

  const data: ExchangeRateResponse = await response.json();

  const exchangeRates: ExchangeRates = {
    rates: data.rates,
    baseCurrency: data.base,
    lastUpdated: new Date(data.time_last_update_unix * 1000).toISOString(),
  };

  // Save to cache
  saveCachedData(baseCurrency, exchangeRates);

  return exchangeRates;
};

export const fetchCurrencyCodeList = async (): Promise<string[]> => {
  const response = await fetch(`${CURRENCIES_RATE_API_URL}`);
  
  if (!response.ok) {
    throw new Error(`Failed to fetch currency list: ${response.statusText}`);
  }

  const data: Record<string, string> = await response.json();
  return Object.keys(data);
};

export const fetchCurrencyList = async (): Promise<Record<string, string>> => {
  const response = await fetch(`${CURRENCIES_RATE_API_URL}`);
  
  if (!response.ok) {
    throw new Error(`Failed to fetch currency list: ${response.statusText}`);
  }

  return await response.json();
};